export const HomePageLayout = {
  slots: [
    'SlbHomePageBannerSlot',
    'SlbTopParagraphSlot',
    'SlbDomainSolutionsSlot',
    'SlbDelfiPlatformSlot',
    'SlbDelfiDescriptionBannerSlot',
    'SlbInfoCardsSlot',
    'SlbCaseStodiesSlot',
    'SlbBlueBottomBannerSlot'
  ],
};

export const HomeFeaturePageLayout = {
  slots: [
    'SlbHomePageFeatureSlot'
  ]
}